import axiosInstance from "api/axiosInstance";
import { batch } from "react-redux";
import { transferToFacilityAction } from "./transfer-to-facility-slice";
import SAlert from "components/Alert";

// Create transfer request (Province role)
export const createTransferToFacility = (data, callback) => dispatch => {
  dispatch(transferToFacilityAction.setLoading(true));
  axiosInstance
    .post("/v1/transfer-to-facility", data)
    .then(response => {
      SAlert({ title: "Success", text: "Transfer request created successfully" });
      batch(() => {
        dispatch(transferToFacilityAction.setError(null));
        dispatch(transferToFacilityAction.setLoading(false));
      });
      if (callback) callback(true);
    })
    .catch(error => {
      dispatch(transferToFacilityAction.setLoading(false));
      if (error?.response?.data?.error) {
        SAlert({
          title: "Error",
          text: error.response.data.error,
          status: "error",
        });
      } else {
        SAlert({
          title: "Error",
          text: "Failed to create transfer request",
          status: "error",
        });
      }
      if (callback) callback(false);
    });
};

// Get transfer requests (Provider role)
export const getTransferToFacilities =
  (pageNumber = 10) =>
  dispatch => {
    dispatch(transferToFacilityAction.setLoading(true));
    axiosInstance
      .get("/v1/transfer-to-facility", {
        params: { pageNumber },
      })
      .then(response => {
        batch(() => {
          dispatch(transferToFacilityAction.setError(null));
          dispatch(transferToFacilityAction.setData(response.data));
          dispatch(transferToFacilityAction.setLoading(false));
        });
      })
      .catch(error => {
        dispatch(transferToFacilityAction.setLoading(false));
        console.log(error);
      });
  };

// Approve transfer requests (Provider role)
export const approveTransferToFacilities = (ids, callback) => dispatch => {
  dispatch(transferToFacilityAction.setLoading(true));
  axiosInstance
    .post("/v1/transfer-to-facility/approve", { ids })
    .then(response => {
      SAlert({ title: "Success", text: "Transfers approved successfully" });
      dispatch(getTransferToFacilities());
      batch(() => {
        dispatch(transferToFacilityAction.setError(null));
        dispatch(transferToFacilityAction.setLoading(false));
      });
      if (callback) callback(true);
    })
    .catch(error => {
      dispatch(transferToFacilityAction.setLoading(false));
      if (error?.response?.data?.error) {
        SAlert({
          title: "Error",
          text: error.response.data.error,
          status: "error",
        });
      } else {
        SAlert({
          title: "Error",
          text: "Failed to approve transfers",
          status: "error",
        });
      }
      if (callback) callback(false);
    });
};

// Reject transfer requests (Provider role)
export const rejectTransferToFacilities = (ids, callback) => dispatch => {
  dispatch(transferToFacilityAction.setLoading(true));
  axiosInstance
    .post("/v1/transfer-to-facility/reject", { ids })
    .then(response => {
      SAlert({ title: "Success", text: "Transfers rejected successfully" });
      dispatch(getTransferToFacilities());
      batch(() => {
        dispatch(transferToFacilityAction.setError(null));
        dispatch(transferToFacilityAction.setLoading(false));
      });
      if (callback) callback(true);
    })
    .catch(error => {
      dispatch(transferToFacilityAction.setLoading(false));
      if (error?.response?.data?.error) {
        SAlert({
          title: "Error",
          text: error.response.data.error,
          status: "error",
        });
      } else {
        SAlert({
          title: "Error",
          text: "Failed to reject transfers",
          status: "error",
        });
      }
      if (callback) callback(false);
    });
};

// Get provinces for transfer (Province role)
export const getTransferProvinces = () => dispatch => {
  dispatch(
    transferToFacilityAction.setProvinces({
      loading: true,
      error: null,
      data: [],
    })
  );
  axiosInstance
    .get("/v1/transfer-provinces")
    .then(response => {
      dispatch(
        transferToFacilityAction.setProvinces({
          loading: false,
          error: null,
          data: response?.data,
        })
      );
    })
    .catch(error => {
      dispatch(
        transferToFacilityAction.setProvinces({
          loading: false,
          error: error?.response,
          data: [],
        })
      );
      console.log(error);
    });
};

// Get facilities for province (Province role)
export const getTransferFacilities = province_id => dispatch => {
  dispatch(
    transferToFacilityAction.setFacilities({
      loading: true,
      error: null,
      data: [],
    })
  );
  axiosInstance
    .get(`/v1/transfer-facilities/${province_id}`)
    .then(response => {
      dispatch(
        transferToFacilityAction.setFacilities({
          loading: false,
          error: null,
          data: response?.data,
        })
      );
    })
    .catch(error => {
      dispatch(
        transferToFacilityAction.setFacilities({
          loading: false,
          error: error?.response,
          data: [],
        })
      );
      console.log(error);
    });
};
